import { useIntl } from "react-intl";

const ServiceAndInfrastructureHealthAnalysis = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ServiceAndInfrastructureHealthAnalysis.header",
            defaultMessage: "Service and infrastructure health analysis"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ServiceAndInfrastructureHealthAnalysis.body",
            defaultMessage:
                "Health analysis gives you a top-level view of all services. This helps you identify problems or improvements within those services."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default ServiceAndInfrastructureHealthAnalysis;
